import { z } from "zod";

export const postTerminalPairingSchema = z.object({
	deviceId: z.string().nonempty(),
	/**
	 * The pairing secret the device already holds, if it has one. Presenting it is what lets a
	 * device re-register on a later boot and be recognised as itself; a device registering for
	 * the first time sends nothing here and is issued one. The server never adopts the value —
	 * it only compares it against the hash the device id is bound to.
	 */
	pairingSecret: z.string().optional(),
});

export type PostTerminalPairingSchema = z.infer<typeof postTerminalPairingSchema>;
